import { EventEmitter } from "./event-emitter";

export default EventEmitter;
